export interface Article {
  slug: string;
  title: string;
  categorySlug: string;
  categoryName: string;
  excerpt: string;
  content: string;
  tags: string[];
  date: string;
  readTime: string;
  featured: boolean;
  imageSeq: string;
}

export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    slug: "fanwen-jingxuan",
    name: "范文精选",
    description: "精选优质范文，涵盖成长经历与家庭教育主题，供学生参考借鉴",
    icon: "ri-article-line",
  },
  {
    slug: "xushi-jiqiao",
    name: "叙事技巧",
    description: "掌握叙事结构、起承转合、时间顺序等核心写作手法",
    icon: "ri-quill-pen-line",
  },
  {
    slug: "qinggan-biaoda",
    name: "情感表达",
    description: "学习如何在作文中自然流露真情实感，打动阅卷老师",
    icon: "ri-heart-line",
  },
  {
    slug: "xijie-miaoxie",
    name: "细节描写",
    description: "用五感观察法、动作分解法等技巧让作文细节生动鲜活",
    icon: "ri-focus-2-line",
  },
  {
    slug: "xiezuo-silu",
    name: "写作思路",
    description: "从选题立意到主题升华，系统提升作文整体构思能力",
    icon: "ri-lightbulb-line",
  },
];

export const articles: Article[] = [
  {
    slug: "na-yi-ci-wo-xuehui-le-chengshi",
    title: "那一次，我学会了诚实",
    categorySlug: "fanwen-jingxuan",
    categoryName: "范文精选",
    excerpt: "小时候因为贪玩打破了邻居家的玻璃，本想隐瞒却被爸爸发现了。那次\"打屁股\"的教训，让我懂得了诚实比逃避更重要。",
    content: `<p>每个人的成长过程中，总会有那么一两件事让人刻骨铭心。对我而言，九岁那年的夏天，至今仍清晰地印在记忆里。</p>
<p>放学后，我和几个小伙伴在小区里踢足球。一个不小心，我奋力的一脚把球踢偏了方向，足球像一颗炮弹似的飞向了邻居王爷爷家的窗户。\"哗啦\"一声脆响，玻璃碎了一地。我们都吓呆了，几个小伙伴面面相觑，然后一哄而散。</p>
<p>我站在原地，心跳得像擂鼓。王爷爷平时对我们很好，总是笑眯眯地给我们糖果吃。我犹豫了许久，最终选择了逃跑。</p>
<p>回到家，我装作若无其事的样子写作业。可爸爸似乎看出了什么，他放下手中的报纸，走到我面前：\"今天放学是不是出了什么事？\"</p>
<p>我支支吾吾地说没有。爸爸的眼神变得严肃起来：\"王爷爷刚才打电话来了。\"</p>
<p>那一刻，我的脸唰地红了。爸爸没有立即发火，只是让我把事情说清楚。听完后，他沉默了一会儿，然后说：\"犯了错误不可怕，可怕的是不敢承认。一个人连承认错误的勇气都没有，将来怎么做个顶天立地的人？\"</p>
<p>说完，爸爸拿起鸡毛掸子在桌子上敲了三下。那声音不大，却像三记重锤砸在我心上。他没有真的动手，但我知道，如果我再撒谎，后果会更严重。</p>
<p>最终，我主动去王爷爷家道歉，用自己攒的零花钱赔了玻璃钱。王爷爷摸着我的头说：\"知错就改，还是好孩子。\"</p>
<p>那一天，我明白了一个道理：诚实是做人的根本。爸爸用他的方式——那在桌子上敲响的三下鸡毛掸子，教会了我这个终身受用的道理。</p>`,
    tags: ["诚实", "成长经历", "家庭教育", "小学作文"],
    date: "2026-07-15",
    readTime: "5分钟",
    featured: true,
    imageSeq: "article-chengshi",
  },
  {
    slug: "mama-de-chengfa-rang-wo-chengzhang",
    title: "妈妈的\"惩罚\"让我成长",
    categorySlug: "fanwen-jingxuan",
    categoryName: "范文精选",
    excerpt: "一次考试作弊被发现后，妈妈没有打骂我，但她独特的\"惩罚\"方式让我终身难忘，也让我真正懂得了诚信的意义。",
    content: `<p>初一下学期期中考试，数学卷子上的一道大题让我束手无策。眼看时间一分一秒过去，我鬼使神差地瞄了一眼同桌的答案。</p>
<p>成绩出来，我考了92分，数学老师还在班上表扬了我。但心里的不安像一块石头，越压越重。</p>
<p>周末，妈妈整理我的书包时，发现了一张写满密密麻麻公式的草稿纸——那是我考前准备的\"小抄\"。她什么也没说，只是让我坐在她对面。</p>
<p>\"这次的数学成绩是你真实的水平吗？\"妈妈的声音很平静，但我知道她什么都已经知道了。</p>
<p>我低着头，眼泪啪嗒啪嗒掉下来。妈妈没有像往常一样来安慰我，而是拿出了一把戒尺。那是外公留下来的老物件，妈妈从没用它打过我。</p>
<p>\"伸出手。\"我战战兢兢地伸出手，戒尺落下来，不重，但足够让我记住。一下、两下、三下。</p>
<p>打完，妈妈的眼圈也红了：\"打你，是让你记住，诚信比分数重要一万倍。今天你抄别人的答案，以后你抄谁的人生？\"</p>
<p>那三下戒尺，打在我手心上，更打在我心里。从那以后，我再也没有在考试中作弊。妈妈的\"惩罚\"不是暴力的宣泄，而是爱的教育。她用最传统的方式，教会了我最根本的道理——做人要诚实，学习要扎实。</p>`,
    tags: ["诚信", "考试", "家庭教育", "初中作文", "成长经历"],
    date: "2026-07-10",
    readTime: "6分钟",
    featured: true,
    imageSeq: "article-mama",
  },
  {
    slug: "ruhe-xiehao-chengzhang-gushi-de-kaitou",
    title: "如何写好成长故事的开头：三种经典写法",
    categorySlug: "xushi-jiqiao",
    categoryName: "叙事技巧",
    excerpt: "一个好的开头能瞬间抓住读者的注意力。本文介绍三种适合成长类作文的开头写法，帮你在考试中脱颖而出。",
    content: `<p>俗话说\"好的开头是成功的一半\"，写作文也是一样的道理。尤其是成长类作文，一个精彩的开头能让阅卷老师眼前一亮，为全文定下良好的基调。今天，我们以\"打屁股\"这个成长经历为例，介绍三种经典的开头写法。</p>
<h4>一、设悬念式开头</h4>
<p>\"啪！\"竹条落下的声音在房间里回荡。我咬着牙，忍着疼，却也在那一刻明白了父亲的良苦用心。</p>
<p>这种开头直接用声音或动作切入，让读者产生好奇心——发生了什么？为什么会这样？接着再娓娓道来，能有效吸引阅卷老师的注意力。</p>
<h4>二、回忆式开头</h4>
<p>每当看到桌上那把老旧的戒尺，我的思绪总会飘回十岁那年的夏天。那是我人生中第一次、也是唯一一次挨打，却也是最珍贵的一课。</p>
<p>由一个物件或场景引出回忆，营造温馨怀旧的氛围，适合情感细腻的同学使用。</p>
<h4>三、感悟式开头</h4>
<p>有人说，孩子是在批评和表扬中长大的。而我觉得，有些成长，恰恰发生在最严厉的惩罚之后。那一次，让我真正理解了什么叫\"打在儿身，疼在娘心\"。</p>
<p>先点明主题，引起读者共鸣，再通过具体事例展开叙述。这种开头显得成熟有深度。</p>
<p>无论选择哪种开头，最重要的是——真情实感。千万不要为了炫技而编造不真实的情节，那样的作文空洞无物，阅卷老师一眼就能看出来。</p>`,
    tags: ["开头写法", "叙事技巧", "作文方法", "考试技巧"],
    date: "2026-07-08",
    readTime: "4分钟",
    featured: false,
    imageSeq: "article-kaitou",
  },
  {
    slug: "yong-xijie-dadong-duzhe-wugan-miaoxiefa",
    title: "用细节打动读者：五感描写法实战指南",
    categorySlug: "xijie-miaoxie",
    categoryName: "细节描写",
    excerpt: "作文干巴巴没味道？学会五感描写法（视觉、听觉、嗅觉、味觉、触觉），让你的文字像电影画面一样生动。",
    content: `<p>很多同学写作文，最常犯的毛病就是\"流水账\"——\"今天我去上学，然后下课了，然后放学回家，然后写作业\"，通篇都是\"然后\"，读起来枯燥乏味。根本原因在于：缺乏细节描写。</p>
<p>今天，我们用具体的例子来学习如何用\"五感\"丰富你的作文。</p>
<h4>视觉描写</h4>
<p>不要只写\"爸爸很生气\"，而要写：\"爸爸的眉头拧成了一个疙瘩，眼睛瞪得像铜铃，手里的戒尺在灯光下泛着冷光。\"</p>
<h4>听觉描写</h4>
<p>不要只写\"我哭了\"，而要写：\"我的呜咽声在安静的房间里显得格外刺耳，混合着戒尺破空的呼呼声，每一下都敲在我心上。\"</p>
<h4>触觉描写</h4>
<p>不要只写\"打得很疼\"，而要写：\"手掌传来一阵火辣辣的刺痛，像是有无数根细针同时扎下去，又像是被滚烫的铁板烫过。\"</p>
<h4>嗅觉描写</h4>
<p>不要只写\"妈妈在做饭\"，而要写：\"厨房里飘来红烧肉的香气，混合着葱姜的辛香，这本是我最爱的味道，此刻却让我更加愧疚。\"</p>
<h4>味觉描写</h4>
<p>不要只写\"我后悔了\"，而要写：\"泪水顺着脸颊流进嘴角，咸咸的、涩涩的，那是我尝过的最不是滋味的味道。\"</p>
<p>记住这个口诀：画面要让人\"看得见\"，声音要让人\"听得到\"，触感要让人\"摸得着\"，气味要让人\"闻得见\"，味道要让人\"尝得出\"。五感齐用，你的作文自然就活了。</p>`,
    tags: ["细节描写", "五感法", "作文方法", "写作技巧"],
    date: "2026-07-05",
    readTime: "5分钟",
    featured: false,
    imageSeq: "article-xijie",
  },
  {
    slug: "rang-qinggan-zai-zuowen-zhong-ziran-liutang",
    title: "让情感在作文中自然流淌：真情实感的表达技巧",
    categorySlug: "qinggan-biaoda",
    categoryName: "情感表达",
    excerpt: "写作文最怕\"假大空\"。本文教你如何把真实的情感融入到作文中，让文字有温度、有力量，真正打动读者。",
    content: `<p>阅卷老师常说的一句话是：\"好作文都是有温度的。\"这个\"温度\"从哪里来？从真情实感中来。</p>
<p>以\"受到惩罚后学会成长\"这类主题为例，来看看如何写出有温度的文字。</p>
<h4>一、不要刻意煽情</h4>
<p>很多同学写这类作文时，喜欢用大量感叹号和夸张的形容词——\"我哭得死去活来\"\"我的心碎成了一片片\"。这样的表达不但不能打动人，反而让人觉得做作。</p>
<p>正确做法：用平实的语言写真实的情感。比如：\"我趴在床上，眼泪把枕头浸湿了一大片。不是因为疼，而是因为后悔——后悔让妈妈失望了。\"这样克制的表达反而更有力量。</p>
<h4>二、用细节承载情感</h4>
<p>情感不必直接说出口，可以通过细节来传达。\"妈妈打完我，转身去了厨房。透过虚掩的门缝，我看见她在偷偷抹眼泪。\"——这比单纯说\"妈妈也很心疼\"要动人得多。</p>
<h4>三、写出情感的转变</h4>
<p>好的成长类作文，情感不是一条直线，而是有起伏和转变的。一开始可能是委屈、不服气，经过某个转折点，转变为理解、感恩。这种转变过程正是作文的核心亮点。</p>
<h4>四、结尾要有升华但不虚浮</h4>
<p>结尾不要写成\"啊，母爱真伟大\"这样的口号式。可以这样写：\"如今那把戒尺还在老家的抽屉里，落满了灰。但每次想起它，想起妈妈红着眼眶的样子，我都觉得那是世界上最温柔的惩罚。\"</p>`,
    tags: ["情感表达", "真情实感", "作文方法", "写作技巧"],
    date: "2026-07-02",
    readTime: "5分钟",
    featured: false,
    imageSeq: "article-qinggan",
  },
  {
    slug: "baba-de-na-yibazhang",
    title: "爸爸的那一巴掌",
    categorySlug: "fanwen-jingxuan",
    categoryName: "范文精选",
    excerpt: "因为偷了同学的新文具盒，爸爸平生第一次打了我一巴掌。那一巴掌不仅打醒了我，更让我学会了尊重他人的东西。",
    content: `<p>那是小学四年级的时候，同桌小明带了一个崭新的变形金刚文具盒来学校，上面印着威风凛凛的擎天柱。我羡慕极了，因为家里条件不太好，我用的还是姐姐传下来的铁皮文具盒，上面的漆都掉了大半。</p>
<p>趁课间操教室没人的时候，我鬼使神差地把那个文具盒塞进了自己的书包。当时心跳得厉害，但虚荣心战胜了理智。</p>
<p>事情败露得很快。小明发现文具盒不见了，老师检查了全班同学的书包。当那个文具盒从我的书包里被翻出来时，全班同学的目光像针一样扎在我身上。</p>
<p>老师把爸爸叫到了学校。我永远忘不了爸爸走进办公室时的表情——那是一种混合了震惊、失望和羞愧的复杂神情。一路上，他一句话也没说。回到家，他才转过身来，扬起了手。</p>
<p>\"啪！\"</p>
<p>那一巴掌又响又脆，我的半边脸火辣辣地烧着。爸爸的手在发抖，眼眶也红了：\"咱们家是穷，但从来不做偷鸡摸狗的事！你要喜欢，跟爸妈说，攒钱给你买。偷人家的东西，丢的不是你的人，是咱们全家的脸！\"</p>
<p>那晚，我躲在被窝里哭了很久。不是因为疼痛，而是因为羞愧和后悔。第二天，爸爸带我去了小明家，让我当面道歉并把文具盒还给了小明。小明的妈妈很通情达理，反而安慰我说\"知错就改就是好孩子\"。</p>
<p>爸爸的那一巴掌，打掉了我心里的虚荣与贪念，也让我真正理解了\"人穷志不短\"的道理。如今我已上了大学，每当面临诱惑时，总会想起那一巴掌，想起爸爸发抖的手和通红的眼眶——那是爱的证据，也是刻在我骨子里的警钟。</p>`,
    tags: ["诚实", "家庭教育", "成长经历", "小学作文", "父爱"],
    date: "2026-06-28",
    readTime: "6分钟",
    featured: true,
    imageSeq: "article-baba",
  },
  {
    slug: "cong-shijian-dao-ganwu-shenghua-zhuti",
    title: "从事件到感悟：如何升华作文主题",
    categorySlug: "xiezuo-silu",
    categoryName: "写作思路",
    excerpt: "很多同学写完事件就草草收尾，作文缺少\"点睛之笔\"。教你如何从具体事件中提炼出深刻的感悟，让作文更有深度。",
    content: `<p>一篇优秀的成长类作文，不仅要写清楚\"发生了什么事\"，更要写出\"我从这件事中学到了什么\"。这个从事件到感悟的升华过程，正是作文的\"点睛之笔\"。</p>
<h4>一、感悟要\"顺理成章\"</h4>
<p>好的感悟不是生硬地贴在文章结尾的一段大道理，而是从事件叙述中自然而然地\"长\"出来的。比如写被家长惩罚的经历，感悟可以是\"那一次惩罚让我懂得了规矩的重要性\"、\"严厉背后是深沉的父爱\"、\"成长往往伴随着疼痛\"等等。</p>
<h4>二、感悟要有\"个性\"</h4>
<p>避免写\"通过这件事，我明白了一个道理\"这样千篇一律的过渡句。可以用更有个性的方式来表达，比如：\"如今回头看，那顿'竹笋炒肉'倒成了我成长路上最独特的一课。\"</p>
<h4>三、感悟要有\"深度\"</h4>
<p>不只是停留在\"以后再也不做坏事了\"这个层面，可以更深一层：理解父母的不易、认识到规则对成长的价值、体会到传统教育方式背后的文化内涵等。</p>
<h4>四、三种升华方式</h4>
<p><strong>对比式升华：</strong>\"以前我觉得爸爸很凶，现在我明白了，那是世界上最温柔的严厉。\"</p>
<p><strong>比喻式升华：</strong>\"成长就像一棵树的年轮，那些疼痛的经历不是伤疤，而是让你变得更坚韧的印记。\"</p>
<p><strong>引用式升华：</strong>\"正如《三字经》所说：'养不教，父之过。教不严，师之惰。'我终于理解了这句话的深意。\"</p>`,
    tags: ["主题升华", "写作思路", "作文方法", "结尾技巧"],
    date: "2026-06-25",
    readTime: "4分钟",
    featured: false,
    imageSeq: "article-ganwu",
  },
  {
    slug: "xiezuo-zhong-de-zhenqing-shigan-ruhe-biaoda",
    title: "写作中的真情实感如何表达：从\"假大空\"到\"真善美\"",
    categorySlug: "qinggan-biaoda",
    categoryName: "情感表达",
    excerpt: "考试作文最忌讳\"假、大、空\"。本文通过具体案例分析，告诉你如何用真实的小事，写出打动人心的好作文。",
    content: `<p>先看两段文字，同样是写\"被妈妈惩罚后明白了道理\"这个主题。</p>
<p><strong>版本A：</strong>\"那天妈妈狠狠地打了我一顿，我伤心极了。通过这件事，我明白了一个道理：妈妈是为我好，以后我一定要好好学习，天天向上，不辜负妈妈的期望！\"</p>
<p><strong>版本B：</strong>\"妈妈的手抬起来又放下，反复了好几次。最后那一下还是落了下来，轻轻的，更像是拍了一下。然后她一把抱住我，声音哽咽：'你知不知道妈妈有多担心？'那一刻，我感觉脖子上凉凉的，那是妈妈的眼泪。\"</p>
<p>看出区别了吗？版本A通篇是空洞的感慨，版本B却用具体细节和真挚情感打动人心。那么，怎样才能写出\"版本B\"这样的文字呢？</p>
<h4>一、从\"小题材\"入手</h4>
<p>不要总想写\"惊天动地\"的大事。一次考试作弊被罚、偷吃零食被发现、撒谎被拆穿——这些都是极好的素材。小事虽小，但因为亲身经历，写出来的情感最真实。</p>
<h4>二、还原当时的感受</h4>
<p>闭上眼睛，回到那个场景。当时你闻到了什么？听到了什么？身体的哪个部位有感觉？心里在想什么？把这些感受如实写下来。</p>
<h4>三、不要\"美化\"自己</h4>
<p>真实的人不是完美的。写作文时，不妨写出自己的\"小心思\"——当时的委屈、不服气、甚至怨恨，都是真实的情感。有了这些铺垫，后面的\"转变\"才更有说服力。</p>
<h4>四、让对话\"活\"起来</h4>
<p>用真实的对话代替概述。\"妈妈说以后不许这样了\"远不如\"妈妈叹了口气：'你啊，什么时候才能让妈省点心？'\"来得动人。</p>`,
    tags: ["真情实感", "情感表达", "写作技巧", "考试作文"],
    date: "2026-06-20",
    readTime: "5分钟",
    featured: false,
    imageSeq: "article-zhenqing",
  },
  {
    slug: "jixuwen-qi-cheng-zhuan-he-jiegou",
    title: "记叙文\"起承转合\"结构详解：让你的故事更有层次",
    categorySlug: "xushi-jiqiao",
    categoryName: "叙事技巧",
    excerpt: "\"起承转合\"是写好记叙文的基本框架。本文用成长类作文为例，帮你掌握这个高效实用的写作结构。",
    content: `<p>很多同学写记叙文，从头到尾平铺直叙，读起来像白开水。根本原因是没有掌握\"起承转合\"这个经典结构。掌握了它，你的作文就有了节奏感和层次感。</p>
<h4>起——引出事件</h4>
<p>交代故事的起因和背景。不需要太长，两三句话即可。例如：\"那是我上五年级时的一个周末，妈妈出门前叮嘱我不要玩电脑游戏。我满口答应，心里却打起了小算盘。\"</p>
<h4>承——事件发展</h4>
<p>详细叙述事件的经过，这是文章的主体部分。注意加入细节描写，让读者\"身临其境\"。写被罚的过程时，可以描写妈妈发现你玩电脑时的表情变化、你自己的心理活动等。</p>
<h4>转——事件转折</h4>
<p>这是全文最精彩的部分。通常是一个关键瞬间——可能是妈妈说了某句触动你的话，可能是你发现了什么，也可能是某个细节让你突然明白了什么。这个\"转\"是情感的爆发点，也是整篇作文的\"戏眼\"。</p>
<h4>合——总结升华</h4>
<p>写出事件对你的影响和你的感悟。不要写得太长，但要写得有分量。好的结尾像喝茶后的回甘，让人回味无穷。</p>
<p>掌握了\"起承转合\"，你的作文就不再是流水账，而是一部有开头、有发展、有高潮、有结尾的完整故事。多加练习，你也能写出让人印象深刻的好作文。</p>`,
    tags: ["起承转合", "叙事结构", "记叙文", "写作技巧"],
    date: "2026-06-18",
    readTime: "4分钟",
    featured: false,
    imageSeq: "article-jiegou",
  },
  {
    slug: "na-yi-ci-jiaoxun-rang-wo-mingbai-le-zeren",
    title: "那一次教训让我明白了责任",
    categorySlug: "fanwen-jingxuan",
    categoryName: "范文精选",
    excerpt: "答应帮邻居照看小狗却因为贪玩忘记喂食，爸爸的严厉惩罚让我第一次理解了什么是\"责任\"二字的分量。",
    content: `<p>那年暑假，邻居李阿姨要出差三天，临走前托我帮忙照看她家的小泰迪\"豆豆\"，还特意给了我五十块钱的\"照看费\"。我拍着胸脯保证一定照顾好豆豆，心里美滋滋地盘算着用这五十块钱买新出的漫画书。</p>
<p>前两天还好好的，到了第三天，我和小伙伴在楼下玩得太投入，完全把豆豆忘在了脑后。等我满头大汗回家时，已经过了喂食时间三个多小时。</p>
<p>打开李阿姨家的门，豆豆正缩在角落里可怜兮兮地叫唤，饭盆和水盆都空了。我手忙脚乱地给它倒狗粮，倒水，心里暗暗祈祷李阿姨不要发现。</p>
<p>但纸包不住火。李阿姨回来后发现豆豆瘦了一圈，精神状态也不好。她没有直接质问我，而是给我爸爸打了电话。</p>
<p>爸爸挂掉电话后，脸色铁青。他让我到书房来，从抽屉里拿出了那根我见过却没挨过的藤条。</p>
<p>\"答应别人的事，就要做到。这叫信用，这叫责任。\"爸爸的声音不大，却每一个字都像钉子一样扎进我心里。</p>
<p>那天晚上，我趴在床上，屁股火辣辣地疼，但更难受的是心里的愧疚。我想起豆豆饿得直叫的样子，想起李阿姨临走时信任的眼神，第一次明白了\"责任\"不是嘴上说说那么简单。</p>
<p>后来我主动把五十块钱还给李阿姨，还用自己攒的零花钱给豆豆买了一袋进口狗粮。李阿姨摸着我的头笑了：\"懂得认错、懂得弥补，说明你真的长大了。\"</p>
<p>如今想来，爸爸那顿打不是体罚，而是一堂关于\"责任\"的人生课。它让我明白，一个人的信誉比任何漫画书都要贵重，而责任，是不能用任何借口去推卸的。</p>`,
    tags: ["责任", "承诺", "家庭教育", "成长经历", "小学作文"],
    date: "2026-06-15",
    readTime: "6分钟",
    featured: true,
    imageSeq: "article-zeren",
  },
];

export const faqItems = [
  {
    question: "这个网站的作文素材适合什么年龄段的学生？",
    answer: "本站的作文范文和写作技巧主要面向小学中高年级（三至六年级）和初中阶段的学生。范文难度适中，写作技巧讲解通俗易懂，家长也可以陪伴阅读并指导孩子练习。",
  },
  {
    question: "文章中的\"打屁股\"会不会对孩子产生负面影响？",
    answer: "本站收录的作文都是以\"教育\"和\"成长\"为核心的，强调的是惩罚背后的爱与道理，引导学生理解父母的良苦用心。我们倡导正面的家庭教育理念，不宣扬暴力，而是关注教育意义和心灵成长。",
  },
  {
    question: "如何使用这些范文帮助孩子提升写作能力？",
    answer: "建议三步走：第一步，让孩子先阅读范文，感受文章的结构和情感；第二步，结合本站的写作技巧文章，学习其中的写作方法；第三步，鼓励孩子根据自身经历进行仿写或创作。家长可以从旁引导，但不要代替孩子思考。",
  },
  {
    question: "文章可以免费阅读和参考吗？",
    answer: "本站所有文章均免费开放阅读。学生可以参考文章结构、写作手法和素材选取方式，但请勿直接抄袭全文，应结合自身经历进行创作，这样才能真正提高写作水平。",
  },
  {
    question: "网站多久更新一次内容？",
    answer: "我们每周会更新2-3篇新文章，涵盖范文、写作技巧和素材分享。建议收藏本站或关注更新动态，获取最新的写作指导内容。",
  },
];

export const testimonials = [
  {
    name: "李妈妈",
    role: "小学五年级学生家长",
    content: "孩子以前写作文总是流水账，自从看了这个网站上的范文和技巧文章，作文水平明显提升，上学期还拿了班级作文二等奖！",
  },
  {
    name: "张老师",
    role: "初中语文教师",
    content: "作为语文老师，我觉得这个网站的内容质量很高。尤其是写作技巧板块，讲解清晰、案例丰富，推荐给了全班同学。",
  },
  {
    name: "小明同学",
    role: "初二学生",
    content: "以前最怕写作文，现在每周都来这个网站看看。特别是那些范文，读完很有启发，写起来也有思路了。",
  },
];